// Routes de la propreté (lot L3-B, M13), raccordées dans Application.tsx par une seule ligne. Les
// chemins fixes précèdent la fiche /proprete/tournees/:id.
import type { RouteObject } from 'react-router';
import { PageCouts } from './PageCouts';
import { PageRealisations } from './PageRealisations';
import { PageSecteurs } from './PageSecteurs';
import { PageTournee } from './PageTournee';
import { PageTournees } from './PageTournees';
import { PageVehicules } from './PageVehicules';

export const routesProprete: RouteObject[] = [
  { path: '/proprete', element: <PageTournees /> },
  { path: '/proprete/secteurs', element: <PageSecteurs /> },
  { path: '/proprete/realisations', element: <PageRealisations /> },
  { path: '/proprete/vehicules', element: <PageVehicules /> },
  { path: '/proprete/couts', element: <PageCouts /> },
  { path: '/proprete/tournees/:id', element: <PageTournee /> },
];
